import { oidcConfig } from '../constants/oidc';

export default function getUserId(): string | null {
  try {
    const storageKey = `oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`;
    const oidcData = sessionStorage.getItem(storageKey);

    if (oidcData) {
      const userData = JSON.parse(oidcData);
      return userData.profile?.sub || userData.sub || null;
    }
  } catch (error) {
    console.warn('Failed to get userId from sessionStorage:', error);
  }
  return null;
}
